module.exports = __webpack_public_path__ + "media/images/arrows_in-outward-88ef5abe.svg";